<app-modal
  modalId="town-materials"
  [showCloseButton]="true"
  [allowEscToClose]="true"
  [closeOnBackdropClick]="true"
>
  <span title>{{ town()?.name ?? 'Town' }} Material Sales</span>

  <div body class="flex flex-col gap-2 max-h-[400px] overflow-y-auto pr-2">
    @for (row of rows(); track row.index) {
      <app-slot-caravan-trade
        [row]="row"
        merchantLabel="town"
        (activate)="requestTrade(row, $event)"
      />
    } @empty {
      <app-blank-slate>
        This town has nothing to sell right now.
      </app-blank-slate>
    }
  </div>
</app-modal>

<app-modal-trade-quantity />
